import React, { useRef, useEffect } from "react"
import { useThree, useFrame } from "react-three-fiber"
import { useControl } from "react-three-gui"
import { useSpring, a } from "react-spring/three"
import * as easings from "d3-ease"
import { sRGBEncoding } from "three"
import { useGesture } from "react-use-gesture"

export default function Camera(props) {
  const { init, handleEnded, fov, delta } = props
  const { setDefaultCamera, gl } = useThree()
  let h = 1
  const properties = useSpring({
    config: {
      duration: 7000,
      easing: easings.easeCubic,
    },
    pos: init ? [-2.5, h, -0.765] : [-0.874, h, 173.454],
    onRest: () => {
      handleEnded()
    },
  })

  // const drag = (state) => {
  //   if (init) {
  //     console.log(camera)
  //     console.log(state.delta)
  //   }
  // }

  // const bind = useGesture({
  //   onDrag: (state) => drag(state),
  // })

  useEffect(() => {
    if (gl) {
      gl.outputEncoding = sRGBEncoding
    }
  }, [gl])

  useEffect(() => void setDefaultCamera(ref.current), [])

  const zoom = useControl("ball position", {
    type: "number",
    value: 1,
    min: 0.5,
    max: 5,
  })
  const ref = useRef()
  // Make the camera known to the system
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // Update it every frame
  useFrame(() => {
    ref.current.updateMatrixWorld()
    ref.current.updateProjectionMatrix()
  })
  useEffect(() => {ref.current.lookAt(-2.5, 1, -0.765)}, [])
  return (
    <a.perspectiveCamera
      position={properties.pos}
      fov={fov}
      ref={ref}
      rotation={[Math.PI / 2, 0, 0]}
      zoom={zoom}
      {...props}
    />
  )
}
